import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { confirmBaremeMsg } from './../../core/models/messages';
import { SortDataService } from './../../core/services/sortdata';
import {
  CreateCallOffer,
  headerColumns5,
  translations,
} from './../../core/models/call-offer';
import { patternName } from './../../core/models/pattern';
import { CallOfferService } from './../../core/services/call-offer-service/call-offer.service';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Country, State } from 'country-state-city';
import { Subject, takeUntil } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { ValidatorFn } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import * as moment from 'moment';
import {
  callofferajout,
  calloffererreur,
  calloffermodifie,
} from './../../core/models/messages';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PaysserviceService } from '@core/services/pays/paysservice.service';
import { PrimeNGConfig } from 'primeng/api';
const DOMPurify = require('dompurify')
function nameValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (typeof control.value === 'string') {
      return null;
    } else {
      return { invalidName: true };
    }
  };
}
@Component({
  selector: 'app-call-offer-client',
  templateUrl: './call-offer-client.component.html',
  styleUrls: ['./call-offer-client.component.css'],
})
export class CallOfferClientComponent {
  listNames: string[] = [];
  idCompany!: number;
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  sortAttr = '';
  name = 'Angular';
  skillsCompany: any;
  skills: any[] = [];
  calljobinfo_info!: CreateCallOffer;
  countries: any = [];
  states: any = [];
  createform: FormGroup = this.registerForm();
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;
  isLoadSpinner: boolean = true;

  loadSpinner: boolean = false;
  listCallOffers: any;
  closeResult = '';
  p: number = 1;
  job_request_id: any;
  isexiste = false;
  displayedItems: any[] = [];
  detailcall: any;
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns5;
  /* any */
  file: any;
  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;

  /* form data */
  formData = new FormData();

  /* subscriprion */
  private unsubscribeAll: Subject<void> = new Subject();
  fileError: string = '';
  fileExtention: string = '';
  mobilities: any[] = [];
  selectedCallOffer: any;
  /* number */
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  currentSortDirection: number = 2;
  dataCallOffer: any;

 disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];

  postType = [
    { id: '1', name: 'A distance' },
    { id: '2', name: 'Hybride' },
    { id: '3', name: 'Sur site' },
  ];
  contratType = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
  ];
  submitted: boolean = false;
  idCallOffer!: number;
  updatedCallOfferData: any;
  dataHeader: any = [];
  postTypeOptions: { [key: string]: string } = {
    '1': 'A distance',
    '2': 'Hybride',
    '3': 'Sur site',
  };
  availabilituyTypeOptions: { [key: string]: string } = {
    '1': 'Immédiate',
    '2': '1 mois',
    '3': '2 mois',
    '4': '3 mois',
    '5': '4 mois',
    '6': '5 mois',
  };

  contratTypeOptions: { [key: string]: string } = {
    '1': 'Alternance',
    '2': 'Autres type de contrat',
    '3': 'CDD',
    '4': 'CDI',
    '5': 'Freelance',
    '6': 'Portage salarial',
    '7': 'Stage',
  };

  dedieau: { [key: string]: string } = {
    '1': 'Dedie au particulier',
    '2': 'Dédié aux ESN',
  };
  showDedicatedToESNCheckbox: boolean = true;

  isDedicatedToParticulier = 1;
  isDedicatedToESN = 2;
  skillsList: { name_FR: string }[] = [];
  /* object */
  contractTypesList: { id: string; name: string }[] = [
    { id: '1', name: 'Alternance' },
    { id: '2', name: 'Autres type de contrat' },
    { id: '3', name: 'CDD' },
    { id: '4', name: 'CDI' },
    { id: '5', name: 'Freelance' },
    { id: '6', name: 'Portage salarial' },
    { id: '7', name: 'Stage' },
    // Ajoutez d'autres types de contrat au besoin
  ];
  Statut: { id: string; name: string }[] = [
    { id: '0', name: 'actif' },
    { id: '1', name: 'inactif' },
  ];
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];

  /* formGroup */
  id: any;
  backGroundColors: string[] = ['blue', 'orange'];
  searchForm: FormGroup = this.createSearchForm();
  idclientConnected: any;
  /* modal */
  modalRef?: BsModalRef;
  stateList: any = [];
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));

  constructor(
    private spinner: NgxSpinnerService,
    private sanitizer: DomSanitizer,
    private callofferservice: CallOfferService,
    private formBuilder: FormBuilder,
    private sortDataService: SortDataService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private localStorageService: LocalStorageService,
    private paysServices:PaysserviceService,
    private elRef: ElementRef,
  ) {}

  toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ header: 1 }, { header: 2 }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'],
  ];

  ngOnInit() {
    this.paysList=this.paysServices.getAllCountries();
    this.id = this.localStorageService.getData('clientConnected');
    this.getListSkills();
    this.countries = Country.getAllCountries();
    this.getListAppel();
    this.getListElementHeader();
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
      console.log('HEYYYYYYYYYYYY');
    }
  }
  /* change country select and delete the string Governorate from state name*/
  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }

  onCountryChange1(mode: string): void {
    this.createform.get('city')?.enable();
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    console.log('item of countries ', this.countries);
    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    console.log('stateList ', this.stateList);
    this.mobilities = this.createform.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      console.log('size of mobilities ', this.mobilities.length);
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.createform.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  onMobilityChange(mode: string) {
    this.mobilities = this.createform.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.createform.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        console.log('difference1 : ', difference1.length);
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            console.log('new_array is ', item.name);
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          } else {
            console.log('String not found in array.', item.name);
          }
        }
      }
    });

    console.log('stateListAfter1 ', stateListAfter1);

    //  this.stateList=stateListAfter1

    this.mobilities = this.createform.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.createform.get('city')?.disable();
      mode == 'add';
      this.createform.get('country')?.setValue(null);
      mode == 'add';
      this.createform.get('city')?.setValue(null);
      this.createform.get('country')!.updateValueAndValidity();
      this.createform.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    } else {
      /*  if(this.countries) {
        this.countries.forEach((item) => {
          console.log('item of countries ', item);
  
        });
      }*/
    }
  }
  
  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  translateCountryName(name: string): string {
  
    return translations[name] || name;
  }
  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'dd/mm/yyyy') || '';
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }
 
 alreadyConverted = false;
 convertKToNumber(value: any): number {
  if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {
    // Si la valeur se termine par 'k'
    const numericValue = parseFloat(value.slice(0, -1));
    if (!isNaN(numericValue)) {
      // Convertir en multipliant par 1000
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return numericValue * 1000;
    }
  } else if (!isNaN(value)) {
    // Si la valeur est déjà un nombre
    if (!this.alreadyConverted) {
      this.alreadyConverted = true; // Marquer comme déjà convertie
      return parseFloat(value) * 1000;
    } else {
      return parseFloat(value); // Retourner la valeur sans multiplier à nouveau
    }
  }

  // Si aucune condition n'est remplie, retourner une valeur par défaut
  return 0; // Ou une autre valeur par défaut appropriée
}

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobRequest: ['', data && data.ID_jobRequest],
      name: ['', data && data.name],
      years_of_experience: ['', data && data.years_of_experience],
      experience_range: ['', data && data.experience_range],
      contract_type: [[], data && data?.contract_type],
      desired_salary: ['', data && data.desired_salary],
      desired_salary_range: ['', data && data.desired_salary_range],
      tjm: ['', data && data.tjm],
      tjm_range: ['', data && data.tjm_range],
      post_type: [[], data && data.post_type],
      skillsOr: [[], data && data.skillsOr],
      skillsAnd: [[], data && data.skillsAnd],
      availability: [[], data && data.availability],
      country: [[], data && data.country],
      city: [[], data && data.city],
      start_date: ['', data && data.start_date],
      end_date: ['', data && data.end_date],
      profile_abroad: [null, data && data.profile_abroad],
      passeport_talent: [null, data && data.passeport_talent],
      state: ['', data && data.state],
      client_id: [''],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  /* filter job offer */
  searchOfferr() {
    let idclient = this.localStorageService.getData('clientConnected');
    this.searchForm.value.desired_salary_range = this.convertKToNumber(
      this.searchForm.value.desired_salary_range.toString()
    );
    let formattedStartDate = this.datePipe.transform(this.searchForm.value.start_date, 'yyyy-MM-dd');
    let   formattedEndDate= this.datePipe.transform(this.searchForm.value.end_date, 'yyyy-MM-dd');
    

    this.spinner.show();
    let data = {
      ID_jobRequest: this.searchForm.value.ID_jobRequest,
      name: this.searchForm.value.name,
      years_of_experience: this.searchForm.value.years_of_experience,
      experience_range: this.searchForm.value.experience_range,
      contract_type: this.searchForm.value.contract_type,
      desired_salary: this.searchForm.value.desired_salary
        ? this.searchForm.value.desired_salary.toString()
        : '',
      desired_salary_range: this.searchForm.value.desired_salary_range
        ? this.searchForm.value.desired_salary_range.toString()
        : '',
      tjm: this.searchForm.value.tjm
        ? this.searchForm.value.tjm.toString()
        : '',
      tjm_range: this.searchForm.value.tjm_range
        ? this.searchForm.value.tjm_range.toString()
        : '',
      post_type: this.searchForm.value.post_type,
      skillsOr: this.searchForm.value.skillsOr,
      skillsAnd: this.searchForm.value.skillsAnd,
      availability: this.searchForm.value.availability,
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      client_final_name: this.searchForm.value.client_final_name,
      state: this.searchForm.value.availability,
      profile_abroad: this.searchForm.value.profile_abroad,
      passeport_talent: this.searchForm.value.passeport_talent,
      sort: this.currentSortDirection,
      city: this.searchForm.value.city,
      country: this.searchForm.value.country,
      sortAttribute: 'name',
      client_id: idclient,
      page: this.currentPage,
      per_page: this.itemsPerPage,
      search: this.transformSearch(this.searchForm.value?.search),
    };
    this.spinner.show();
    console.log('data to send', data);
    this.callofferservice
      .searchRequestOffer(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          if (this.currentPage > 1) {
            this.currentPage = 1;
            this.searchOfferr();
          } else {
            this.spinner.hide();
            this.listCallOffers = res.data.data.slice(0, this.endIndex);
            this.totalItems = res.data.total;
          }
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  reset() {
    this.stateList=[];
    this.currentPage = 1;
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListAppel();
  }
  initForm(data?: any): void {
    this.createform = this.registerForm(data);
  }

  selectCallOffer(callOffer: any) {
    this.selectedCallOffer = { ...callOffer };
  }
  registerForm(data?: any) {
    const defaultCallOffer: CreateCallOffer = {
      name: data ? data.name : '',
      post_type: data ? data.post_type : '',
      city: data ? data.city : '',
      country: data ? data.country : '',
      availability: data ? data.availability : '',
      salary: data ? data.salary : '',
      years_of_experience: data ? data.years_of_experience : '',
      contract_type: data ? data.contract_type : '',
      tjm: data ? data.tjm : '',
      description: data ? data.description : '',
      skills: data ? data.skills : [],
      dedicated_to: data ? data.dedicated_to : [],
      profile_abroad: data ? data.profile_abroad : '',
      passeport_talent: data ? data.passeport_talent : '',
      otherSkills: data ? data.otherSkills : [],
    };

    return this.formBuilder.group({
      name: [
        data ? data.name : '',
        [Validators.required, Validators.pattern(patternName)],
      ],
      post_type: [data ? data.post_type : null],
      city: [data ? data.city : [], Validators.required],
      country: [data ? data.country : []],
      availability: [data ? data.availability : null],
      salary: [data ? data.salary : ''],
      years_of_experience: [
        data ? data.years_of_experience : '',
        Validators.required,
      ],
      contract_type: [data ? data.contract_type : []],
      tjm: [data ? data.tjm : ''],
      description: [data ? data.description : '', Validators.required],
      skills: [data ? data.skills : []],
      otherSkills: [data ? data.otherSkills : []],
      dedicated_to: [data ? data.dedicated_to : [], Validators.required],
      profile_abroad: [data ? data.profile_abroad : '', Validators.required],
      passeport_talent: [
        data ? data.passeport_talent : '',
        Validators.required,
      ],
      role_id: 4,
    });
  }

  sanitizeDescription(html: string): string {
    const sanitizedDescription: SafeHtml =
      this.sanitizer.bypassSecurityTrustHtml(html);
    const plainTextDescription = this.stripHtmlTags(
      sanitizedDescription.toString()
    );
    return plainTextDescription;
  }

  stripHtmlTags(html: string): string {
    return html ? html.replace(/<[^>]*>/g, '') : '';
  }
  getListSkills() {
    this.callofferservice.getSkillsCompany().subscribe({
      next: (res) => {
        this.skillsList = res.data;
        console.log('  this.skillsList', this.skillsList);
      },
      error: (err) => {
        console.log('error', err);
      },
    });
  }
  ajoutProfilecalloffer() {
    let id = this.localStorageService.getData('clientConnected');
    console.log('value of form groupe ', this.createform.value);
    const formData = new FormData();
    formData.append('name', this.createform.value.name);
    formData.append('post_type', this.createform.value.post_type);
    formData.append('country', this.createform.value.country);
    formData.append('city', this.createform.value.city);
    formData.append('availability', this.createform.value.availability);
    formData.append(
      'salary',
      this.createform.value.salary ? String(this.createform.value.salary) : '0'
    );
    formData.append(
      'years_of_experience',
      this.createform.value.years_of_experience
    );
    // formData.append("contract_type", this.createform.value.contract_type);
    const contractTypes = this.createform.value.contract_type;
    console.log('contractTypes:', contractTypes);
    if (Array.isArray(contractTypes)) {
      for (const contractType of contractTypes) {
        formData.append('contract_type[]', contractType);
      }
    }
    console.log('contractTypes:', contractTypes);

    formData.append(
      'tjm',
      this.createform.value.tjm ? String(this.createform.value.tjm) : '0'
    );

    formData.append('client_id', id ? id : '');
    formData.append(
      'profile_abroad',
      this.createform.value.profile_abroad ? '1' : '0'
    );
    formData.append(
      'passeport_talent',
      this.createform.value.passeport_talent ? '1' : '0'
    );

    if (this.createform.value.dedicated_to === true) {
      formData.append(
        'dedicated_to',
        this.createform.value.dedicated_to ? '1' : '0'
      );
    }
    console.log('******', this.createform.value.dedicated_to);
    const skills = this.createform.get('skills')?.value;
    for (const skill of skills) {
      formData.append('skills[]', skill.id);
    }
    if (this.createform.value.description === null) {
      formData.delete('description');
    }
    if (this.createform.value.availability === null) {
      formData.delete('availability');
    }
    if (this.createform.value.post_type === null) {
      formData.delete('post_type');
    }
 
    this.callofferservice
      .createCallOffer(formData)
      .pipe()
      .subscribe({
        next: (res) => {
          this.calljobinfo_info = res.data;
          this.dataCallOffer = res.data;
          this.toastr.success(callofferajout);
          this.dataCallOffer = this.dataCallOffer.id;
          this.confirmBareme(this.dataCallOffer);
          this.spinner.hide();
          this.closeModal();
          this.getListAppel();
        },
        error: (err) => {
          console.log('error', err);
          this.toastr.error(calloffererreur);
        },
      });
  }

  confirmBareme(job_request_id: any) {
    Swal.fire({
      title: `${confirmBaremeMsg}`,
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Confirmer',
      confirmButtonColor: '#265D91',
      cancelButtonText: 'Ignorer',
      iconColor: '#28a745',
    }).then((result) => {
      if (result.isConfirmed) {
        this.navigateToAddBareme(job_request_id);
      }
    });
    this.closeModalconfirm();
  }
  closeModalconfirm() {
    this.modalRef?.hide();
  }

  navigateToAddBareme(job_request_id: any) {
    this.router.navigate([
      'call-offer-bareme',
      { job_request_id:job_request_id,state:'update' },
    ]);
  }
  // Fonction pour vérifier si une valeur est numérique
  isNumeric(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }
  /* get indexes for pagination */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.createform.dirty) {
        this.searchOfferr();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListAppel();
      }
    }
  }

  closeModal() {
    this.stateList=[];
    this.modalRef?.hide();
    this.createform.reset();
    this.formData = new FormData();
    this.file = null;
    this.fileError = '';
    this.fileExtention = '';
  }

  sortData(item: string) {
    for (const iterator of headerColumns5) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listCallOffers = this.sortDataService.sortArray(
        this.listCallOffers,
        item,
        this.currentSortDirection
      );
    else this.getListAppel();
  }
  getListAppel() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? { id: this.id, per_page: this.itemsPerPage, page: this.currentPage }
        : {
            ...{
              id: this.id,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    console.log('data', dataPyload);
    this.callofferservice
      .getListOfferRequest(this.id, dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listCallOffers = res.data.data
          // .slice(0, this.endIndex);
          console.log('calloffer', this.listCallOffers);
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  // deletecalloffer(id: any) {
  //   Swal.fire({
  //     title: 'Êtes-vous sûr(e) ?',
  //     text: 'Vous ne pourrez pas revenir en arrière !',
  //     icon: 'warning',
  //     showCancelButton: true,
  //     iconColor: '#ff0000',
  //     confirmButtonColor: '#3085D6',
  //     cancelButtonColor: '#d33',
  //     confirmButtonText: 'Oui, supprimer !',
  //     cancelButtonText: 'Annuler',
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.callofferservice.deleteCallOffer(id).subscribe((res: any) => {
  //         console.log('responce', res);
  //         Swal.fire('Supprimé !', "L'appel d'offre a été supprimé.", 'success');
  //         this.getListAppel();
  //       });
  //     }
  //   });
  // }
  desactiverjoboffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment désactiver cette appel d’offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, désactivé !',
      cancelButtonText: 'Annuler ',
    }).then((result) => {
      if (result.isConfirmed) {
        this.callofferservice.deleteCallOffer(id).subscribe({
          next: (response: any) => {
            console.log('response', response);

            console.log('response.data', response.data);
            this.toastr.success(
              'L’appel Offre a été désactivé avec succès.'
            );
            this.searchOfferr();
          },
          error: (error: any) => {
            console.error('Error fetching  job offer: ', error);
          },
        });
      }
    });
  }
  activerjoboffer(id: any) {
    Swal.fire({
      title: 'Voulez-vous vraiment activer cette appel d’offre ?',
      // text: "Vous ne pourrez pas revenir en arrière !",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, activé !',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.callofferservice.activerjoboffer(id).subscribe({
          next: (response: any) => {
            console.log('response', response);

            console.log('response.data', response.data);
            this.toastr.success(
              'L’offre d’emploi a été activé avec succès .'
            );
            this.searchOfferr();
          },
          error: (error: any) => {
            console.error('Error fetching  job offer: ', error);
          },
        });
      }
    });
  }

  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.idCallOffer = data.id;
    console.log('data', data);
    this.createform = this.registerForm(data);
    this.createform.get('contract_type')?.setValue(data.contract_type);
    const cityTypes = this.createform.value.city;
    console.log('cityTypes:', cityTypes);
    if (Array.isArray(cityTypes)) {
      for (const cityType of cityTypes) {
        this.createform.get('city[]')?.setValue(cityType);
      }
    }
    const countryTypes = this.createform.value.country;
    console.log('cityTypes:', countryTypes);
    if (Array.isArray(countryTypes)) {
      for (const countryType of countryTypes) {
        this.createform.get('country[]')?.setValue(data.city);
      }
    }
    // this.createform.get('country')?.setValue(data.country);
    // console.log('country', data.country);
    // this.createform.get('city')?.setValue(data.city);
    // console.log('cityyyyyyyyyyyyyyyy', this.createform.value.city);
    console.log('skills_job', data.skills_job);
    this.skills = [];
    let skillsArray = data.skills_job;
    console.log('skillsArray', skillsArray);
    if (skillsArray.length != 0) {
      for (let i = 0; i < skillsArray.length; i++) {
        this.skills.push(skillsArray[i].subCateg_id);
      }
    }
    console.log('skills id', this.skills);
    this.createform.get('skills')?.setValue(this.skills);
    console.log('skillIds', this.createform);
    console.log('updatte---', this.createform.value);
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }

  updateCALLOFFER() {
    // Traitement des skills
    this.skills = [];
    const skills = this.createform.get('skills')?.value;
    if (skills) {
      this.skills = Array.isArray(skills) ? skills : [skills];
    }
    console.log('skills', this.skills);
  
    // Traitement des autres attributs
    let otherSkills = this.createform.get('otherSkills')?.value;
    if (typeof otherSkills === 'string' && otherSkills) {
      otherSkills = otherSkills.split(',').map(skill => skill.trim());
    }
    console.log('otherSkills', otherSkills);
  
    const city = this.createform.get('city')?.value;
    const country = this.createform.get('country')?.value;
  
    const formattedCity = typeof city === 'string' ? JSON.parse(city) : city;
    const formattedCountry = typeof country === 'string' ? JSON.parse(country) : country;
  
    this.createform.patchValue({
      salary: this.createform.value.salary ? String(this.createform.value.salary) : '0',
      tjm: this.createform.value.tjm ? String(this.createform.value.tjm) : '0',
      years_of_experience: String(this.createform.value.years_of_experience),
      otherSkills: otherSkills || [],
      city: formattedCity || [],
      country: formattedCountry || []
    });
  
    // Nettoyage des valeurs nulles ou vides
    // for (let key in this.createform.value) {
    //   if (
    //     this.createform.value[key] === null ||
    //     this.createform.value[key].length === 0
    //   ) {
    //     delete this.createform.value[key];
    //   }
    // }
    
    console.log("form update", this.createform.value);
    this.spinner.show();
    this.callofferservice
      .updateCallOffer(this.idCallOffer, this.createform.value)
      .subscribe((res: any) => {
        this.spinner.hide();
        this.createform.reset();
        this.closeModal();
        this.toastr.success(calloffermodifie);
        this.getListAppel()
      });
  }

  openModal1(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
  }
  /* key inter number */
  keyPress(event: any) {
    let pattern = /^[\d]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && pattern && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    return pattern;
  }

  /* ************************* navigation company ********************* */
  profilCallNavigation(id: any) {
    this.router.navigate(['detail-offre-clientfinal', { id: id }]);
  }

  changeSkills(data: any) {
    for (const iterator of data) {
      // TableDateCell.push(iterator.id)
    }
  }
  updateSkills(event: any): void {
    this.createform.get('skills')?.setValue(event);
  }
  getListElementHeader() {
    // if(!this.typeintervenant){
    this.callofferservice
      .getHeaderElementscandidatcf(19)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
              console.log("listnames",this.listNames)
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => {},
      });
    // }
    // else
    // {
    //   this.candidatservice
    //   .listPageActorIntervenant()
    //   .pipe(takeUntil(this.unsubscribeAll))
    //   .subscribe({
    //     next: (res) => {
    //       this.dataHeader = res.data;
    //       for (const iterator of this.dataHeader) {
    //         if (
    //           (iterator.checked == 'oui' && !iterator.checked_user) ||
    //           (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
    //           (iterator.checked == 'oui' && iterator.checked_user == 'oui')
    //         )
    //           this.listNames.push(iterator.name);
    //       }
    //       this.dataHeader.map((el: any) => {
    //         if (
    //           (el.checked == 'oui' && !el.checked_user) ||
    //           (el.checked_user == 'oui' &&
    //             (el.checked == 'non' || el.checked == 'oui'))
    //         ) {
    //           return (el.checkAdmin = true);
    //         } else {
    //           return (el.checkAdmin = false);
    //         }
    //       });
    //     },
    //     error: () => { },
    //   });
    // }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    // if(!this.typeintervenant)
    //   {
    let payload = {
      sub_page_id: data?.id,
    };
    this.callofferservice
      .changeDelectedElementHeadercandidatcf(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {},
        error: () => {},
      });
    // }
    // else{
    //   let payload = {
    //     sub_page_id: data?.id
    //   }
    //   this.candidatservice.changeSubPageStateIntervenant(payload).pipe(takeUntil(this.unsubscribeAll)).subscribe({
    //     next: (res) => {

    //     },
    //     error: () => {

    //     }
    //   })
    // }
  }
  onContentChange(event: any): void {
    if (event.html) {
      const sanitizedContent = DOMPurify.sanitize(event.html);
      if (sanitizedContent !== this.createform.get('description')?.value) {
        this.createform.patchValue(
          { description: sanitizedContent },
          { emitEvent: false } 
        );
      }
    }

  }
}
